// Shared limits for Chatwoot outbound message attachments. Imported by both the
// frontend composer (via the src/lib/shared symlink) and the Cloud Function, so
// the client validates against the exact limits the server and Storage rules
// enforce — bump a value here and both sides move together.
//
// NOTE: storage.rules cannot import TypeScript, so its `25 * 1024 * 1024`
// literal must be kept in sync with MAX_OUTBOUND_ATTACHMENT_BYTES by hand.
export const OUTBOUND_ATTACHMENT_PREFIX = 'chatwoot-attachments'
export const MAX_OUTBOUND_ATTACHMENTS = 10
export const MAX_OUTBOUND_ATTACHMENT_BYTES = 25 * 1024 * 1024
// Aggregate cap across every attachment in a single message — guards against a
// payload large enough to hit the send deadline or Chatwoot's request-size limit.
export const MAX_OUTBOUND_TOTAL_BYTES = 40 * 1024 * 1024

// Ceiling for downloading an inbound attachment back through the callable. The
// constraint here is the callable response budget, not Chatwoot's upload
// limit: the bytes travel as base64 inside a JSON payload, which inflates them
// by 4/3, so 15 MiB of file becomes ~20 MiB of response. That leaves ample
// headroom under the platform's response cap. Anything larger is refused with
// `resource-exhausted` and the client falls back to opening the file in a tab.
export const MAX_INBOUND_ATTACHMENT_DOWNLOAD_BYTES = 15 * 1024 * 1024
